<script lang="ts">
export default { name: 'Pin' };
</script>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import type { PinEmits } from '../../types/pin.type';
import { usePin } from './usePin';

const emits = defineEmits<PinEmits>();

const router = useRouter();

const { pinFlow, currentComponent, zIndex, onClose } = usePin(
  emits,
  () => router?.currentRoute.value.fullPath
);
</script>

<template>
  <div
    v-if="pinFlow.show.value"
    data-test="modal:pin"
    :style="{ zIndex }"
    class="w-full h-full top-0 bg-gray-10 fixed font-montserrat"
  >
    <component :is="currentComponent" @close="onClose" />
  </div>
</template>
